import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h1 className="text-danger text-center m-5">Oooops........Page not Found 404</h1>
        </div>
    );
};

export default NotFound;